
(function () {
  'use strict';

  var root = document.querySelector('[data-cookie-consent]');
  if (!root || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  var modal = root.querySelector('[data-cookie-modal]');
  var overlay = root.querySelector('[data-cookie-overlay]');
  var preferencesInput = root.querySelector('[data-consent-preferences]');
  var analyticsInput = root.querySelector('[data-consent-analytics]');
  var marketingInput = root.querySelector('[data-consent-marketing]');
  var lastFocusedElement = null;

  function showBanner() {
    root.hidden = false;
  }

  function hideBanner() {
    root.hidden = true;
    closePreferences();
  }

  function openPreferences() {
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    overlay.hidden = false;
    document.body.classList.add('cookie-preferences-open');
    var closeButton = modal.querySelector('[data-cookie-close]');
    if (closeButton) closeButton.focus();
  }

  function closePreferences() {
    modal.hidden = true;
    overlay.hidden = true;
    document.body.classList.remove('cookie-preferences-open');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function consentToBoolean(value) {
    return value === 'yes';
  }

  function populatePreferences(api) {
    var consent = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
    preferencesInput.checked = consentToBoolean(consent.preferences);
    analyticsInput.checked = consentToBoolean(consent.analytics);
    marketingInput.checked = consentToBoolean(consent.marketing);
  }

  function saveConsent(api, values) {
    api.setTrackingConsent(
      {
        preferences: Boolean(values.preferences),
        analytics: Boolean(values.analytics),
        marketing: Boolean(values.marketing)
      },
      function () {
        hideBanner();
      }
    );
  }

  function bindEvents(api) {
    root.querySelectorAll('[data-cookie-accept]').forEach(function (button) {
      button.addEventListener('click', function () {
        saveConsent(api, {
          preferences: true,
          analytics: true,
          marketing: true
        });
      });
    });

    root.querySelectorAll('[data-cookie-reject]').forEach(function (button) {
      button.addEventListener('click', function () {
        saveConsent(api, {
          preferences: false,
          analytics: false,
          marketing: false
        });
      });
    });

    root.querySelectorAll('[data-cookie-preferences]').forEach(function (button) {
      button.addEventListener('click', function () {
        populatePreferences(api);
        openPreferences();
      });
    });

    root.querySelectorAll('[data-cookie-save]').forEach(function (button) {
      button.addEventListener('click', function () {
        saveConsent(api, {
          preferences: preferencesInput.checked,
          analytics: analyticsInput.checked,
          marketing: marketingInput.checked
        });
      });
    });

    root.querySelectorAll('[data-cookie-close]').forEach(function (button) {
      button.addEventListener('click', closePreferences);
    });

    overlay.addEventListener('click', closePreferences);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closePreferences();
    });
  }

  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1'
      }
    ],
    function (error) {
      if (error || !window.Shopify.customerPrivacy) return;

      var api = window.Shopify.customerPrivacy;
      bindEvents(api);

      var consent = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
      var undecided =
        !consent ||
        (consent.analytics === '' &&
          consent.marketing === '' &&
          consent.preferences === '');

      if (api.shouldShowBanner && api.shouldShowBanner() && undecided) {
        showBanner();
      }
    }
  );
})();
